import React from 'react'
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom'

import SecureRoutes from './SecureRoutes'
import SessionProvider from './features/SessionProvider'
import { Login } from './features/Auth'
import LKModal from './features/shared/LKModal'
import FileDetails from './features/FileDetails'

const Router = () => (
  <HashRouter>
    <SessionProvider>
      <Switch>
        <Route path="/auth/login" component={Login} />
        <Route path="/secure" component={SecureRoutes} />
        <Redirect to="/secure" />
      </Switch>
      <LKModal.Error />
      <LKModal.Info />
      <FileDetails />
    </SessionProvider>
  </HashRouter>
)

export default Router
